export default __webpack_public_path__ + "static/media/boberContent3.442ac95b.mp4";